import type {
  PeekPriceModalFerryPlusHotelItinerary,
  PeekPriceModalFlightPlusHotelItinerary,
  PeekPriceModalHotelOnlyItinerary,
  PeekPriceModalItineraryData,
  PeekPriceModalMultiIngredientItinerary,
} from './itinerary';
import { PeekPriceModalItineraryType } from './itinerary';

export function isPeekPriceModalHotelOnlyItinerary(
  itinerary: PeekPriceModalItineraryData
): itinerary is PeekPriceModalHotelOnlyItinerary {
  return itinerary.type === PeekPriceModalItineraryType.HotelOnly;
}

export function isPeekPriceModalFlightPlusHotelItinerary(
  itinerary: PeekPriceModalItineraryData
): itinerary is PeekPriceModalFlightPlusHotelItinerary {
  return itinerary.type === PeekPriceModalItineraryType.FlightPlusHotel;
}

export function isPeekPriceModalFerryPlusHotelItinerary(
  itinerary: PeekPriceModalItineraryData
): itinerary is PeekPriceModalFerryPlusHotelItinerary {
  return itinerary.type === PeekPriceModalItineraryType.FerryPlusHotel;
}

export function isPeekPriceModalMultiIngredientItinerary(
  itinerary: PeekPriceModalItineraryData
): itinerary is PeekPriceModalMultiIngredientItinerary {
  return itinerary.type === PeekPriceModalItineraryType.MultiIngredient;
}
